export interface ProductStock {
  reorderLevel: number;
  onHand: number;
  quarantinedQty?: number;
  recalledQty?: number;
}

export function isBelowReorder(product: Pick<ProductStock, 'reorderLevel' | 'onHand'>): boolean {
  return product.reorderLevel > 0 && product.onHand <= product.reorderLevel;
}

export function blockedStockNotes(product: Pick<ProductStock, 'quarantinedQty' | 'recalledQty'>): { label: string; qty: number }[] {
  const notes: { label: string; qty: number }[] = [];
  if ((product.quarantinedQty ?? 0) > 0) notes.push({ label: 'Quarantined', qty: product.quarantinedQty ?? 0 });
  if ((product.recalledQty ?? 0) > 0) notes.push({ label: 'Recalled', qty: product.recalledQty ?? 0 });
  return notes;
}

export const SUPPLIER_FILTERS = [
  { value: '', label: 'All suppliers' },
  { value: 'true', label: 'Active only' },
  { value: 'false', label: 'Inactive only' },
] as const;

export interface SupplierIdentity {
  id: string;
  code: string;
  name: string;
  paymentTermsDays: number;
  contactPerson?: string | null;
  phone?: string | null;
  email?: string | null;
  address?: string | null;
  taxNumber?: string | null;
}

export function supplierActivationBody(supplier: SupplierIdentity, isActive: boolean) {
  return {
    id: supplier.id,
    code: supplier.code,
    name: supplier.name,
    paymentTermsDays: supplier.paymentTermsDays,
    contactPerson: supplier.contactPerson || undefined,
    phone: supplier.phone || undefined,
    email: supplier.email || undefined,
    address: supplier.address || undefined,
    taxNumber: supplier.taxNumber || undefined,
    isActive,
  };
}

export interface GoodsReceivedState {
  voidedAt?: string | null;
}

export function isVoidedReceipt(receipt: GoodsReceivedState): boolean {
  return Boolean(receipt.voidedAt);
}

export function canVoidReceipt(receipt: GoodsReceivedState, mayManage: boolean): boolean {
  return mayManage && !isVoidedReceipt(receipt);
}
